import {
  downloadChallanReport,
  downloadEventReport,
  downloadItemReport,
  downloadKeyReport,
  downloadStockReport,
  getAllEvent,
  getCategory,
  getItem,
} from "_services";
import {
  ButtonHeading,
  CommonDate,
  CommonModal,
  CustomSelect,
} from "components";
import { Images } from "constants";
import { errorSchema, utils } from "helper";
// import useDocumentTitle from "hooks/useDocumentTitle";
import { QuickUploadModal } from "modals";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { LiaTruckSolid } from "react-icons/lia";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import axios from "axios";

const Reports = () => {
  //   useDocumentTitle("Quick Upload | T360");

  const reasonList = [
    { label: "KEY LOST", value: 1 },
    { label: "LOCKER UNLOCK REQUEST", value: 2 },
    { label: "MASTER KEY ACCESS", value: 3 },
  ];
  const navigate = useNavigate();
  const [quickUploadOpen, setQuickUploadOpen] = useState(false);
  const [challanOpen, setChallanOpen] = useState(false);
  const [stackOpen, setStackOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);
  const [keyOpen, setkeyOpen] = useState(false);
  
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    event_id: "",
    category_id: "",
    start_date: "",
    end_date: "",
    item_id: "",
    reason:""
  });
  const [formError, setFormError] = useState("");
  const [allEventList, setAllEventList] = useState([]);
  const [allCategoryList, setAllCategoryList] = useState([]);

  const token = localStorage.getItem("token");
  const [data, setData] = useState([]);
  useEffect(() => {
    if (quickUploadOpen ||keyOpen) getEventList();
  }, [quickUploadOpen,keyOpen]);

  useEffect(() => {
    if (challanOpen || stackOpen) getCategoryList();
  }, [challanOpen, stackOpen]);

  useEffect(() => {
    if (itemOpen) getItemList();
  }, [itemOpen]);

  const handleSubmit = async () => {
    const getFileExtension = (contentType) => {
      const mimeMap = {
        "application/pdf": "pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          "xlsx",
        "application/vnd.ms-excel": "xls",
        "text/csv": "csv",
        "application/zip": "zip",
      };
      return mimeMap[contentType] || "txt"; // Default to .txt if unknown
    };

    try {
      setIsLoading(true);
      const res = await downloadEventReport({ id: form.event_id });
      if (res?.status == 200) {
        const contentType = res.headers["content-type"];
        const fileExtension = getFileExtension(contentType);
        const fileName = `guests_report.${fileExtension}`;
        setIsLoading(false);
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/octet-stream" })
        );
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        link.click();
        clearForm();
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleChallanSubmit = async (url = "") => {
    const getFileExtension = (contentType) => {
      const mimeMap = {
        "application/pdf": "pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          "xlsx",
        "application/vnd.ms-excel": "xls",
        "text/csv": "csv",
        "application/zip": "zip",
      };
      return mimeMap[contentType] || "txt"; // Default to .txt if unknown
    };
    try {
      const payload = {
        category_id: form.category_id,
        start_date: form.start_date,
        end_date: form.end_date,
      };
      setIsLoading(true);
      const filterParams = new URLSearchParams();

      Object.keys(payload).forEach((key) => {
        if (payload[key]) {
          filterParams.append(key, payload[key]);
        }
      });
      const res = await downloadChallanReport(url, filterParams.toString());
      if (res?.status == 200) {
        const contentType = res.headers["content-type"];
        const fileExtension = getFileExtension(contentType);
        const fileName = `challan_report.${fileExtension}`;
        setIsLoading(false);
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/octet-stream" })
        );
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        link.click();
        clearForm();
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleStack = async (url = "") => {
    const getFileExtension = (contentType) => {
      const mimeMap = {
        "application/pdf": "pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          "xlsx",
        "application/vnd.ms-excel": "xls",
        "text/csv": "csv",
        "application/zip": "zip",
      };
      return mimeMap[contentType] || "txt"; // Default to .txt if unknown
    };

    try {
      const payload = {
        category_id: form.category_id,
      };
      setIsLoading(true);
      const filterParams = new URLSearchParams();

      Object.keys(payload).forEach((key) => {
        if (payload[key]) {
          filterParams.append(key, payload[key]);
        }
      });
      const res = await downloadStockReport(url, filterParams.toString());
      if (res?.status == 200) {
        const contentType = res.headers["content-type"];
        const fileExtension = getFileExtension(contentType);
        const fileName = `stock_report.${fileExtension}`;
        setIsLoading(false);
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/octet-stream" })
        );
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        link.click();
        clearForm();
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleItem = async (url = "") => {
    const getFileExtension = (contentType) => {
      const mimeMap = {
        "application/pdf": "pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          "xlsx",
        "application/vnd.ms-excel": "xls",
        "text/csv": "csv",
        "application/zip": "zip",
      };
      return mimeMap[contentType] || "txt"; // Default to .txt if unknown
    };

    try {
      const validationResult = await utils.checkFormError(
        {
          ...form,
        },
        errorSchema.reportItemSchema
      );

    
      // if (validationResult==true) {
        const payload = {
          item_id: form.item_id,
        };
        setIsLoading(true);
        const filterParams = new URLSearchParams();

        Object.keys(payload).forEach((key) => {
          if (payload[key]) {
            filterParams.append(key, payload[key]);
          }
        });
        const res = await downloadItemReport(url, filterParams.toString());
        if (res?.status == 200) {
          const contentType = res.headers["content-type"];
          const fileExtension = getFileExtension(contentType);
          const fileName = `item_report.${fileExtension}`;
          setIsLoading(false);
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/octet-stream" })
          );
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          link.click();
          clearForm();
        } else {
          setIsLoading(false);
        }
      // } else {
      //   setFormError(validationResult);
      // }
    } catch (error) {
      setFormError('');
      setIsLoading(false);
    }
  };

  const handleKey = async (url = "") => {
    const getFileExtension = (contentType) => {
      const mimeMap = {
        "application/pdf": "pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          "xlsx",
        "application/vnd.ms-excel": "xls",
        "text/csv": "csv",
        "application/zip": "zip",
      };
      return mimeMap[contentType] || "txt"; // Default to .txt if unknown
    };

    try {
        const payload = {
          reason: form.reason,
          event_id: form.event_id,
        };
        setIsLoading(true);
        const filterParams = new URLSearchParams();

        Object.keys(payload).forEach((key) => {
          if (payload[key]) {
            filterParams.append(key, payload[key]);
          }
        });
        const res = await downloadKeyReport(url, filterParams.toString());
        if (res?.status == 200) {
          const contentType = res.headers["content-type"];
          const fileExtension = getFileExtension(contentType);
          const fileName = `key_report.${fileExtension}`;
          setIsLoading(false);
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/octet-stream" })
          );
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          link.click();
          clearForm();
        } else {
          setIsLoading(false);
        }
     
    } catch (error) {
      setFormError('');
      setIsLoading(false);
    }
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };
      return updatedForm;
    });
  };

  const handleOnChangeItem = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.reportItemSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const getEventList = async () => {
    try {
      const res = await getAllEvent({ limit: "all" });

      if (res?.status === 200) {
        const filterEvent = res.results?.find((i) => i?.is_active === true);
        const list = res.results?.map((i) => ({
          ...i,
          label: i?.event_name,
          value: i?.id,
        }));
        setAllEventList(list);
        setForm({ ...form, event_id: filterEvent?.id });
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const getCategoryList = async (url = "") => {
    console.log();
    try {
      const filterParams = new URLSearchParams();

      Object.keys({ limit: "all" }).forEach((key) => {
        if ({ limit: "all" }[key]) {
          filterParams.append(key, { limit: "all" }[key]);
        }
      });
      const res = await getCategory(url, filterParams.toString());

      if (res?.status === 200) {
        const list = res.results?.map((i) => ({
          ...i,
          label: i?.name,
          value: i?.id,
        }));
        setAllCategoryList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const getItemList = async (url = "") => {
    try {
      const filterParams = new URLSearchParams();

      Object.keys({ limit: "all" }).forEach((key) => {
        if ({ limit: "all" }[key]) {
          filterParams.append(key, { limit: "all" }[key]);
        }
      });
      const res = await getItem(url, filterParams.toString());

      if (res?.status === 200) {
        const list = res.results?.map((i) => ({
          ...i,
          label: i?.name,
          value: i?.id,
        }));
        setAllCategoryList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

 

  const clearForm = () => {
    setChallanOpen(false);
    setQuickUploadOpen(false);
    setStackOpen(false);
    setItemOpen(false);
    setkeyOpen(false)
    setForm((pre) => ({
      event_id: "",
      category_id: "",
      start_date: "",
      end_date: "",
      item_id: "",
    }));

    setFormError('');
  };

  const stockProps = {
    isOpen: stackOpen,
    title: "",
    closeModal: clearForm,
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Download Stock Reports",
    submitTitle: "Download",
    onSubmit: handleStack,
    disabled: isLoading,
    isLoadding: isLoading,
  };

  const quickProps = {
    isOpen: quickUploadOpen,
    title: "",
    closeModal: clearForm,
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Download Guest Reports",
    submitTitle: "Download",

    onSubmit: handleSubmit,
    disabled: isLoading,
    isLoadding: isLoading,
  };
  const challanProps = {
    isOpen: challanOpen,
    title: "",
    closeModal: clearForm,
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Download Challan Reports",
    submitTitle: "Download",

    onSubmit: handleChallanSubmit,
    disabled: isLoading,
    isLoadding: isLoading,
  };

  const itemProps = {
    isOpen: itemOpen,
    title: "",
    closeModal: clearForm,
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Download Item Reports",
    submitTitle: "Download",
    onSubmit: handleItem,
    disabled: isLoading,
    isLoadding: isLoading,
  };

  const keyProps = {
    isOpen: keyOpen,
    title: "",
    closeModal: clearForm,
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Download Key Reports",
    submitTitle: "Download",
    onSubmit: handleKey,
    disabled: isLoading,
    isLoadding: isLoading,
  };

  return (
    <>
      <ButtonHeading
        title="Reports"
        // onClick={{}} buttonTitle="Reports Sharing"
      />

      <div>
        <div className="accordion" id="quickUploadAccordion">
          <div className="accordion-body">
            <div className="row">
              <div className="col-12 ">
                <div className="__qwkMain_bx">
                  <div
                    className="_quickCards"
                    disabled={isLoading}
                    onClick={() => {
                      setStackOpen(true);
                    }}
                  >
                    <div className="_quickCards_body">
                      <div className="text-center">
                        <p className="_fasTruck">
                          {/* <svg
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            id="meteor-icon-kit__solid-inventory"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_525_127)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M1 0C1.55228 0 2 0.447715 2 1V8H5C4.44772 8 4 7.55228 4 7V5C4 4.44772 4.44772 4 5 4H9C9.55228 4 10 4.44772 10 5V7C10 7.55228 9.55228 8 9 8H13C12.4477 8 12 7.55228 12 7V3C12 2.44772 12.4477 2 13 2H19C19.5523 2 20 2.44772 20 3V7C20 7.55228 19.5523 8 19 8H22V1C22 0.447715 22.4477 0 23 0C23.5523 0 24 0.447715 24 1V23C24 23.5523 23.5523 24 23 24C22.4477 24 22 23.5523 22 23V22H2V23C2 23.5523 1.55228 24 1 24C0.447715 24 0 23.5523 0 23V1C0 0.447715 0.447715 0 1 0ZM22 20H19C19.5523 20 20 19.5523 20 19V15C20 14.4477 19.5523 14 19 14H14C13.4477 14 13 14.4477 13 15V19C13 19.5523 13.4477 20 14 20H10C10.5523 20 11 19.5523 11 19V13C11 12.4477 10.5523 12 10 12H5C4.44772 12 4 12.4477 4 13V19C4 19.5523 4.44772 20 5 20H2V10H22V20Z"
                                fill="black"
                              />
                            </g>

                            <defs>
                              <clipPath id="clip0_525_127">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg> */}
                          <div className="reports_icon">
                            <img
                              src={Images.STOCKREPORT}
                              alt="Loading..."
                              className="loader-gif"
                            />
                            <p className="__qwText">{"STOCK REPORTS"}</p>
                          </div>
                        </p>
                        {/* <small className="hash-text">#43534</small> */}
                      </div>
                    </div>
                  </div>

                  <div
                    className="_quickCards"
                    onClick={() => setQuickUploadOpen(true)}
                  >
                    <div className="_quickCards_body">
                      <div className="text-center">
                        <p className="_fasTruck">
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_525_127)">
                              <path
                                d="M14.0001 4.66669C15.2378 4.66669 16.4247 5.15835 17.2999 6.03352C18.1751 6.90869 18.6667 8.09568 18.6667 9.33335C18.6667 10.571 18.1751 11.758 17.2999 12.6332C16.4247 13.5084 15.2378 14 14.0001 14C12.7624 14 11.5754 13.5084 10.7002 12.6332C9.82508 11.758 9.33341 10.571 9.33341 9.33335C9.33341 8.09568 9.82508 6.90869 10.7002 6.03352C11.5754 5.15835 12.7624 4.66669 14.0001 4.66669ZM14.0001 7.00002C13.3812 7.00002 12.7878 7.24585 12.3502 7.68344C11.9126 8.12102 11.6667 8.71452 11.6667 9.33335C11.6667 9.95219 11.9126 10.5457 12.3502 10.9833C12.7878 11.4209 13.3812 11.6667 14.0001 11.6667C14.6189 11.6667 15.2124 11.4209 15.65 10.9833C16.0876 10.5457 16.3334 9.95219 16.3334 9.33335C16.3334 8.71452 16.0876 8.12102 15.65 7.68344C15.2124 7.24585 14.6189 7.00002 14.0001 7.00002ZM14.0001 15.1667C17.1151 15.1667 23.3334 16.7184 23.3334 19.8334V23.3334H4.66675V19.8334C4.66675 16.7184 10.8851 15.1667 14.0001 15.1667ZM14.0001 17.3834C10.5351 17.3834 6.88341 19.0867 6.88341 19.8334V21.1167H21.1167V19.8334C21.1167 19.0867 17.4651 17.3834 14.0001 17.3834Z"
                                fill="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_525_127">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg> */}
                          <div className="reports_icon">
                            <img
                              src={Images.GUESTREPORT}
                              alt="Loading..."
                              className="loader-gif"
                            />
                            <p className="__qwText"> GUEST LIST</p>
                          </div>
                        </p>
                        {/* <small className="hash-text">#43534</small> */}
                      </div>
                    </div>
                  </div>
                  <div
                    className="_quickCards"
                    onClick={() => setChallanOpen(true)}
                  >
                    <div className="_quickCards_body">
                      <div className="text-center">
                        <p className="_fasTruck">
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            fill="none"
                            viewBox="0 0 24 24"
                            color="black"
                          >
                            <g clip-path="url(#clip0_525_127)">
                              <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M10 3v4a1 1 0 0 1-1 1H5m8-2h3m-3 3h3m-4 3v6m4-3H8M19 4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1ZM8 12v6h8v-6H8Z"
                              />
                            </g>
                          </svg> */}
                          <div className="reports_icon">
                            <img
                              src={Images.CHALLANREPORT}
                              alt="Loading..."
                              className="loader-gif"
                            />
                            <p className="__qwText"> CHALLAN</p>
                          </div>
                        </p>
                        {/* <small className="hash-text">#43534</small> */}
                      </div>
                    </div>
                  </div>
                  <div
                    className="_quickCards"
                    onClick={() => setItemOpen(true)}
                  >
                    <div className="_quickCards_body">
                      <div className="text-center">
                        <p className="_fasTruck">
                          <div className="reports_icon">
                            <img
                              src={Images.ITEMREPORT}
                              alt="Loading..."
                              className="loader-gif"
                            />
                            <p className="__qwText"> ITEM</p>
                          </div>
                        </p>
                        {/* <small className="hash-text">#43534</small> */}
                      </div>
                    </div>
                  </div>
                  <div
                    className="_quickCards"
                    onClick={() => setkeyOpen(true)}
                  >
                    <div className="_quickCards_body">
                      <div className="text-center">
                        {/* <p className="_fasTruck"> */}
                          <div className="reports_icon">
                            <img
                              src={Images.KEYREPORT}
                              alt="Loading..."
                              className="loader-gif"
                            />
                            <p className="__qwText"> KEY</p>
                          </div>
                        {/* </p> */}
                        {/* <small className="hash-text">#43534</small> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {quickUploadOpen && (
        <CommonModal {...quickProps}>
          <div className="_plcMod_body" style={{ padding: "20px" }}>
            <div className="flxInr">
              <div className="singleDiv">
                <CustomSelect
                  name="event_id"
                  label="Event"
                  placeholder="Select Event "
                  onSelect={(data) => {
                    handleOnChange("event_id", data.value);
                  }}
                  value={allEventList?.find((i) => i.value == form?.event_id)}
                  options={allEventList.length ? allEventList : []}
                  focus={!!formError?.event_id}
                  error={formError.event_id}
                  enableSearch={true}
                />
              </div>
            </div>
          </div>
        </CommonModal>
      )}
      {quickUploadOpen && <div className="offBack_drop"></div>}

      {challanOpen && (
        <CommonModal {...challanProps}>
          <div className="_plcMod_body" style={{ padding: "20px" }}>
            <div className="flxInr">
              <div className="singleDiv">
                <CustomSelect
                  name="category_id"
                  label="Category"
                  placeholder="Select Category "
                  onSelect={(data) => {
                    handleOnChange("category_id", data.value);
                  }}
                  value={allCategoryList?.find(
                    (i) => i.value == form?.category_id
                  )}
                  options={allCategoryList.length ? allCategoryList : []}
                  focus={!!formError?.category_id}
                  error={formError.category_id}
                  enableSearch={true}
                />
              </div>
              <div className="singleDiv">
                <CommonDate
                  name="date"
                  label="Start Date"
                  placeholder="Start Date"
                  startDate={form?.start_date}
                  setStartDate={(data) => {
                    setForm((s) => ({
                      ...s,
                      start_date: utils.formatDate(data),
                    }));
                  }}
                />
              </div>
              <div className="singleDiv">
                <CommonDate
                  name="date"
                  label="End Date"
                  placeholder="End Date"
                  startDate={form?.end_date}
                  setStartDate={(data) => {
                    setForm((s) => ({
                      ...s,
                      end_date: utils.formatDate(data),
                    }));
                  }}
                />
              </div>
            </div>
          </div>
        </CommonModal>
      )}
      {challanOpen && <div className="offBack_drop"></div>}

      {stackOpen && (
        <CommonModal {...stockProps}>
          <div className="_plcMod_body" style={{ padding: "20px" }}>
            <div className="flxInr">
              <div className="singleDiv">
                <CustomSelect
                  name="category_id"
                  label="Category"
                  placeholder="Select Category "
                  onSelect={(data) => {
                    handleOnChange("category_id", data.value);
                  }}
                  value={allCategoryList?.find(
                    (i) => i.value == form?.category_id
                  )}
                  options={allCategoryList.length ? allCategoryList : []}
                  focus={!!formError?.category_id}
                  error={formError.category_id}
                  enableSearch={true}
                />
              </div>
            </div>
          </div>
        </CommonModal>
      )}
      {stackOpen && <div className="offBack_drop"></div>}

      {itemOpen && (
        <CommonModal {...itemProps}>
          <div className="_plcMod_body" style={{ padding: "20px" }}>
            <div className="flxInr">
              <div className="singleDiv">
                <CustomSelect
                  name="item_id"
                  label="Item"
                  placeholder="Select Item "
                  onSelect={(data) => {
                    handleOnChangeItem("item_id", data.value);
                  }}
                  value={allCategoryList?.find((i) => i.value == form?.item_id)}
                  options={allCategoryList.length ? allCategoryList : []}
                  focus={!!formError?.item_id}
                  error={formError.item_id}
                  enableSearch={true}
                />
              </div>
            </div>
          </div>
        </CommonModal>
      )}

{keyOpen && (
        <CommonModal {...keyProps}>
          <div className="_plcMod_body" style={{ padding: "20px" }}>
            <div className="flxInr">
            <div className="singleDiv">
                <CustomSelect
                  name="event_id"
                  label="Event"
                  placeholder="Select Event "
                  onSelect={(data) => {
                    handleOnChange("event_id", data.value);
                  }}
                  value={allEventList?.find((i) => i.value == form?.event_id)}
                  options={allEventList.length ? allEventList : []}
                  focus={!!formError?.event_id}
                  error={formError.event_id}
                  enableSearch={true}
                />
              </div>
              <div className="singleDiv">
                <CustomSelect
                  name="reason"
                  label="Reason"
                  placeholder="Select Reason "
                  onSelect={(data) => {
                    handleOnChange("reason", data.value);
                  }}
                  value={reasonList?.find((i) => i.value == form?.reason)}
                  options={reasonList.length ? reasonList : []}
                  focus={!!formError?.reason}
                  error={formError.reason}
                  enableSearch={true}
                />
              </div>
            </div>
          </div>
        </CommonModal>
      )}
      {itemOpen && <div className="offBack_drop"></div>}
    </>
  );
};

export default Reports;
